import { LoadingButton } from "@mui/lab";
import { Box } from "@mui/material";
import React, { useState } from "react";
import { toast } from "react-toastify";
import DefaultApiService from "../../../../infrastructure/api/default";
import { ReactComponent as DocumentDownloadIcon } from "../../../assets/icons/document-download.svg";

const ExportExcelButton = ({ exportApi, filterValues }) => {
  const [loading, setLoading] = useState(false);

  const onGetExport = async () => {
    try {
      setLoading(true);
      const result = await DefaultApiService.postApi(
        exportApi + "/ExportExcel",
        filterValues
      );
      setLoading(false);

      if (result.isSuccess && result?.data?.link) {
        window.open(result?.data?.link, "_blank");
      }
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message || "خطایی رخ داده است.");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <LoadingButton
        variant="outlined"
        color="success"
        startIcon={<DocumentDownloadIcon width={16} height={16} />}
        onClick={onGetExport}
        loading={loading}
      >
        Excel
      </LoadingButton>
    </Box>
  );
};

export default ExportExcelButton;
